<script>
export default {
    page() {
        const isTrending = this.mainComponent === 'TrendingMixes'
        const title = isTrending ? 'Trending Mixes' : 'Latest Mixes'
        const description = isTrending
            ? 'The most popular electronic music mixes right now on FRISKY'
            : 'The latest electronic music mixes on FRISKY'
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = isTrending
            ? 'https://frisky.fm/browse/mixes/trending'
            : 'https://frisky.fm/browse/mixes/latest'
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed } from 'vue'
import { useStore } from '@composables/use-store'
import Layout from '@layouts/main-layout'
import LatestMixes from '@views/browse-mixes/browse-latest-mixes'
import TrendingMixes from '@views/browse-mixes/browse-trending-mixes'
import RecentlyPlayedMixes from '@views/browse-mixes/browse-recently-played-mixes'

// `<component :is>` resolves a STRING against registered components, never against
// <script setup> bindings — the routes hand this view the name of the tab to render, so the
// name has to be mapped back to the component here.
const MAIN_COMPONENTS = {
    LatestMixes,
    TrendingMixes,
    RecentlyPlayedMixes,
}

const TABS = [
    { to: { name: 'browse/mixes/latest' }, label: 'Latest' },
    { to: { name: 'browse/mixes/trending' }, label: 'Trending' },
]

const AUTH_TABS = [
    ...TABS,
    { to: { name: 'browse/mixes/recently' }, label: 'Recently Played' },
]

const props = defineProps({
    mainComponent: {
        type: String,
        default: 'LatestMixes',
    },
})

const store = useStore()

const mainView = computed(() => MAIN_COMPONENTS[props.mainComponent])

const loggedIn = computed(() => store.getters['auth/loggedIn'])

const tabs = computed(() => (loggedIn.value ? AUTH_TABS : TABS))
</script>

<template>
    <Layout>
        <BaseContent
            class="page"
            title="Mixes"
        >
            <BaseTabPanel
                :tabs="tabs"
                class="tabs"
                is-underlined
                is-unpadded
                address-navigation
            />
            <component
                :is="mainView"
                class="component"
            />
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.tabs {
    margin-bottom: $s-xxl;
}

.page {
    min-height: 101vh;
}
</style>
